import styled from "styled-components/macro";
import { Button } from "@mui/material";

export const HighlightColor = "#337ab7";
export const SecondaryColor = "lightgray";

export const Head = styled(Button)`
  width: 100%;
  min-height: 64px;
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  &:hover {
    background: #eeeeee;
  }
`;

export const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;

  span {
    font-size: 14px;
  }

  p {
    font-weight: 700;
    font-size: 16px;
  }
`;

export const HeadLeft = styled.div`
  display: flex;
  height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const HeadRight = styled.div`
  flex-basis: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;

  svg {
    transform: ${(props) =>
      props.$isOpen ? "rotate(-90deg)" : "rotate(0deg)"};
    transition: transform 200ms ease-in;
  }
`;

export const BodyLeft = styled.div`
  height: 100%;
  flex: 1;
  flex-basis: 400px;
  min-width: 400px;
  padding: 12px;
  border-right: 1px solid lightgray;
`;

export const BodyRight = styled.div`
  height: 100%;
  flex-shrink: 0;
  flex-basis: 360px;
  min-width: fit-content;
  padding: 12px;
`;

export const Wrapper = styled.div`
  background: ${(props) => (props.$isOpen ? "#eeeeee" : "#eeeeee80")};
  min-height: 64px;
  border: 1px solid ${(props) => (props.$isOpen ? "lightgray" : "#eeeeee")};
  width: 100%;
  border-radius: 4px;
  margin-bottom: ${(props) => (props.$isOpen ? 16 : 0)}px;
  transition: all 300ms ease-in;
`;

export const Body = styled.div`
  width: 100%;
  background: white;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
`;

export const BodyItem = styled.div`
  height: 100%;
  flex: 1;
  padding: 8px;
  border-bottom: 1px solid lightgray;
`;

export const OptionsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
  padding: 8px 4px;
`;

export const OptionWrapSmall = styled.div`
  height: 18px;
  min-width: 18px;
  border-radius: 4px;
  background: ${(props) => (props.iscorrect === "Y" ? "#337ab7" : "lightgray")};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 4px;

  span {
    font-size: 10px;
    font-weight: 600;
    color: ${(props) => (props.iscorrect === "Y" ? "white" : "black")};
  }
`;

export const OptionDividerSmall = styled.div`
  margin: 0px 2px;
  width: 1px;
  height: 16px;
  background: lightgray;
`;
